<template>
  <main class="container">
    <div class="row text-left mb-2">
      <div class="col-lg-12">
        <h3 class="text-color-orange font-size-24">
          <span class="span-hr-orange-left"></span>KATEGORI
        </h3>
        <!-- <p class="font-size-15">Testimoni dari SMA 1 Indonesia</p> -->
      </div>
    </div>
    <div class="header">
      <h2></h2>
      <nav>
        <button
          class="mr-2 btn"
          @click="prev"
          :class="{ active: hasPrev, inactive: !hasPrev }"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="m9.8 12 5 5a1 1 0 1 1-1.4 1.4l-5.7-5.7a1 1 0 0 1 0-1.4l5.7-5.7a1 1 0 0 1 1.4 1.4l-5 5z"
            />
          </svg>
        </button>
        <button
          class="btn"
          @click="next"
          :class="{ active: hasNext, inactive: !hasNext }"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="m14.3 12.1-5-5a1 1 0 0 1 1.4-1.4l5.7 5.7a1 1 0 0 1 0 1.4l-5.7 5.7a1 1 0 0 1-1.4-1.4l5-5z"
            />
          </svg>
        </button>
      </nav>
    </div>

    <vue-horizontal
      ref="horizontal"
      class="horizontal"
      :button="false"
      @scroll-debounce="onScrollDebounce"
    >
      <div
        class="item"
        v-for="(item, index) in category_list"
        :key="`category_${index}`"
      >
        <!-- <div
          class="image"
          :style="{ background: `url(${item.img.srcset.sm})` }"
        >
          <div class="overlay">
            <div class="text">{{ item.img.credit.name }}</div>
          </div>credit
        </div> -->

        <div class="image mb-4">
          <img class="image-product" :src="item.icon" alt="" />
          <h4 class="text-center mt-2">{{ item.name }}</h4>
        </div>
      </div>
    </vue-horizontal>
  </main>
</template>

<script>
// For convenience sake, I import a collection of images from unsplash.
import VueHorizontal from "vue-horizontal";
import broker from "../../../../utils/broker";

export default {
  name: "KategoriGreen",
  data() {
    return {
      category_list: [],
      items: [1, 2, 3, 4, 5, 6, 7],
      hasPrev: false,
      hasNext: true,
    };
  },
  components: { VueHorizontal },
  mounted() {
    this.getDataCategory();
  },
  methods: {
    getDataCategory() {
      let self = this;
      broker.fetch.get(`/webschool/enterpreneur/category`).then((res) => {
        res.data.data.forEach((item) => {
          self.category_list.push(item);
        });
      });
    },
    prev() {
      this.$refs.horizontal.prev();
    },
    next() {
      this.$refs.horizontal.next();
    },
    onScrollDebounce({ hasPrev, hasNext }) {
      this.hasPrev = hasPrev;
      this.hasNext = hasNext;
    },
  },
};
</script>

<!-- Content Design -->
<style lang="scss" scoped>
.image {
  /* background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  padding-top: 100%;
  position: relative;
  background-color: white; */
  background: #ffffff;
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  box-shadow: 1px 4px 19px rgba(75, 75, 75, 0.08);
  border-radius: 5px;
  padding: 12% 0% 12% 0%;

  .image-product {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
  }

  h4 {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 128.2%;
  }
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  background: linear-gradient(
    345deg,
    #00000080 0,
    #00000060 5%,
    #00000040 20%,
    #00000000 50%
  );
}

.overlay {
  .text {
    padding: 12px;
    line-height: 1;
    font-weight: 700;
    font-size: 14px;
    color: white;
  }
}

.content {
  margin-top: 6px;
}

.content {
  h6 {
    font-size: 14px;
    text-transform: capitalize;
    line-height: 1.5;
  }
}

.header {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

nav {
  display: flex;
  align-items: center;
}

svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
  color: white;
}

button.inactive svg {
  color: #bbb;
}

button {
  padding: 4px;
  border-radius: 100px;
  background: #f0542d;
  border-color: #f0542d;
}

button:focus {
  outline: none;
}
</style>

<!-- Parent CSS (.container) -->
<style lang="scss" scoped>
main {
  padding: 24px;
}

@media (min-width: 768px) {
  main {
    padding: 2% 0% 2% 0% !important;
  }
}
</style>

<!-- Responsive Breakpoints -->
<style lang="scss" scoped>
.horizontal {
  --count: 2;
  --gap: 16px;
}

@media (min-width: 640px) {
  .horizontal {
    --count: 3;
    --gap: 24px;
  }
}

@media (min-width: 768px) {
  .horizontal {
    --count: 4;
  }
}

@media (min-width: 1024px) {
  .horizontal {
    --count: 5;
  }
}

@media (min-width: 1280px) {
  .horizontal {
    --count: 6;
  }
}

.item {
  width: calc((100% - ((var(--count) - 1) * var(--gap))) / var(--count));
  margin-right: var(--gap);
}
</style>
